import { defineStyleConfig } from "@chakra-ui/styled-system";

export const formLabelTheme = defineStyleConfig({
  baseStyle: {
    color: "gray.700",
  },
});
